(function() {
    'use strict';
    angular
        .module('serviciosocialApp')
        .factory('SSActividad', SSActividad);

    SSActividad.$inject = ['$resource', 'DateUtils'];

    function SSActividad ($resource, DateUtils) {
        var resourceUrl =  'api/s-s-actividads/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.altaReg = DateUtils.convertDateTimeFromServer(data.altaReg);
                        data.bajaReg = DateUtils.convertDateTimeFromServer(data.bajaReg);
                        data.ultActReg = DateUtils.convertDateTimeFromServer(data.ultActReg);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
